import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { PaymentsComponent } from "./components";

const paymentRoutes: Routes = [
  {
    path: "",
    component: PaymentsComponent,
    data: { title: "Payments" },
  },
];

@NgModule({
  imports: [RouterModule.forChild(paymentRoutes)],
  exports: [RouterModule],
})
export class PaymentsRoutingModule {}
